import { Injectable } from '@angular/core';
import { NavbarService } from './navbar.service';
import { BreadcrumbElement } from './model/breadcrumb';

@Injectable({
  providedIn: 'root',
})
export class BreadcrumbService {
  breadcrumb: BreadcrumbElement[] = [];

  constructor(private navbarService: NavbarService) {}

  setBreadcrumbElements(breadcrumbElements: BreadcrumbElement[]): void {
    this.removeAllBreadcrumbElement();
    breadcrumbElements.forEach((breadcrumbElement: BreadcrumbElement) => this.addBreadcrumbElement(breadcrumbElement));
  }

  addBreadcrumbElement(breadcrumbElement: BreadcrumbElement): void {
    if (
      this.breadcrumb.filter(
        (element) => element.label === breadcrumbElement.label && element.link === breadcrumbElement.link
      ).length === 0
    ) {
      this.breadcrumb.push(breadcrumbElement);
      if (breadcrumbElement.link) {
        this.navbarService.addBreadcrumbElement(
          this.truncateLabel(breadcrumbElement.label, 27),
          breadcrumbElement.link
        );
      } else {
        this.navbarService.addBreadcrumbElement(this.truncateLabel(breadcrumbElement.label, 27));
      }
    }
  }

  removeLastBreadcrumbElement(): void {
    if (this.breadcrumb.length > 0) {
      this.breadcrumb.pop();
      this.navbarService.removeLastBreadcrumbElement();
    }
  }

  removeAllBreadcrumbElement(): void {
    const removeCount = this.breadcrumb.length;
    for (let i = 0; i < removeCount; i++) {
      this.removeLastBreadcrumbElement();
    }
  }

  truncateLabel(label: string, charsMaxNumber: number): string {
    if (label.length <= charsMaxNumber) {
      return label;
    }
    return label.slice(0, charsMaxNumber) + '...';
  }
}
